import React, { useEffect, useMemo, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { CircularLoader, PaperBorderType, Paper as RocPaper, TextField } from '@roc/ui';
import { observer } from 'mobx-react';
import { Button } from '@roc/ui';
import { Save } from '@material-ui/icons';
import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useRoutes } from '../../../hooks/useRoutes';
import { useStore } from '../../../hooks/useStore';

const useStyles = makeStyles({
  table: {
  },
});

export const ATFbutNotFundedQuestionnaire = observer(() => {
  const classes = useStyles();
  const { loanRoutesConfig } = useRoutes();
  const theme = useTheme();
  const store = useStore();
  const { loansAgreedButNotFunded } = store.loanStore;

  useEffect(() => {
    store.loanStore.getAccountLoansAgreedButNotFunded();
  }, []);

  const chosenOther = loansAgreedButNotFunded.some(x => x.reason === 'Other');

  if (loansAgreedButNotFunded.length == 0) {
    return null;
  }

  const showSaveButton = (index) => {
    if (loansAgreedButNotFunded[index]?.reason == 'Other') {
      return loansAgreedButNotFunded[index]?.otherReason != '';
    } else {
      return loansAgreedButNotFunded[index]?.reason != ''
    }
  }

  const saveReason = (index) => {
    store.loanStore.saveAccountLoansAgreedButNotFunded(index);
  }


  return (
    <Box mt={3}>
      <RocPaper borderType={PaperBorderType.SOLID_BORDER} title='Loans that have been agreed at least 5 days'>
        <Box m={2} mt={0}>
          <Alert severity="error">The loans in the list below have been agreed for 5 days, but have no closing date set. Please let us know how these closings are going.</Alert>
        </Box>
        <Table className={classes.table} aria-label="simple table" size='small'>
          <TableHead>
            <TableRow>
              <TableCell width={100}><strong>Loan Id</strong></TableCell>
              <TableCell width={300}><strong>Deal Name</strong></TableCell>
              <TableCell width={300}><strong>Reason</strong></TableCell>
              {
                chosenOther &&
                <TableCell width={300}></TableCell>
              }
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loansAgreedButNotFunded.map((row, index) => (
              <TableRow key={row.loanId}>
                <TableCell component="th" scope="row">
                  <a href={loanRoutesConfig.loans(row.dealid).children.dashboard.url} style={{
                    color: theme.palette.primary.dark
                  }}>
                    <strong>{row.dealid}</strong>
                  </a>
                </TableCell>
                <TableCell>
                  <a href={loanRoutesConfig.loans(row.dealid).children.dashboard.url} style={{
                    color: theme.palette.primary.dark
                  }}>
                    <strong>{row.dealName}</strong>
                  </a>
                </TableCell>
                <TableCell>
                  <FormControl variant="outlined" size='small' fullWidth>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={loansAgreedButNotFunded[index]?.reason}
                      onChange={(e) => {
                        loansAgreedButNotFunded[index].reason = e.target.value;
                      }}
                    >
                      <MenuItem value={'Title work issue'}>Title work issue</MenuItem>
                      <MenuItem value={'Probate court / auction issue / short sale issue'}>Probate court / auction issue / short sale issue</MenuItem>
                      <MenuItem value={'Still negotiating terms with borrower'}>Still negotiating terms with borrower</MenuItem>
                      <MenuItem value={'Communication is going too slow (Our Attorney)'}>Communication is going too slow (Our Attorney)</MenuItem>
                      <MenuItem value={'Communication is going too slow (Title/Attorney of borrower)'}>Communication is going too slow (Title/Attorney of borrower)</MenuItem>
                      <MenuItem value={'Other'}>Other</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                {
                  chosenOther &&
                  <TableCell>
                    {
                      loansAgreedButNotFunded[index]?.reason == 'Other' &&
                      <TextField
                        testId="other"
                        required
                        variant="outlined"
                        size="small"
                        fullWidth
                        multiline
                        minRows={1}
                        value={loansAgreedButNotFunded[index].otherReason}
                        onChange={(e) => {
                          loansAgreedButNotFunded[index].otherReason = e.target.value;
                        }}
                      />
                    }
                  </TableCell>
                }
                <TableCell>
                  {
                    showSaveButton(index) &&
                    <Button testId='saveReason' startIcon={<Save />} variant='contained' size='small' color='primary'
                      onClick={() => {
                        saveReason(index);
                      }}>
                      Save
                    </Button>
                  }
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </RocPaper>
    </Box>
  );
});
